import { Fragment } from 'react'

const Footer = () => {
    return (
        <Fragment>

            <footer className="footer">
                Created at Juno College by Raid Naji.
            </footer>
            
        </Fragment>
    )

}

export default Footer;